import type { FlatObject, NestedObject } from '@ps-smart-cp/ppfw-client';
import { Numeric, removeCommas } from '@ps-smart-cp/ppfw-client';

function isBlankValue(value: unknown): boolean {
  return value === null || value === undefined || value === '';
}

function isSameAsSuggestion(
  attribute: FlatObject | NestedObject | undefined,
  input: unknown,
  suggestion: unknown,
): boolean {
  const inputIsBlank = isBlankValue(input);
  const suggestionIsBlank = isBlankValue(suggestion);
  if (inputIsBlank && suggestionIsBlank) {
    return true;
  }
  if (inputIsBlank !== suggestionIsBlank) {
    return false;
  }
  if (attribute instanceof Numeric) {
    return Number(removeCommas(String(input))) === Number(removeCommas(String(suggestion)));
  }
  if (input instanceof Date && suggestion instanceof Date) {
    return input.getTime() === suggestion.getTime();
  }
  return input === suggestion;
}

export { isBlankValue, isSameAsSuggestion };
